export default "__VITE_ASSET__CHqvgMFE__"